import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Contractor } from 'src/app/models';
import { LayoutService } from 'src/app/services/layout.service';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';

@Component({
    selector: 'wm-select-contractor-details',
    templateUrl: './select-contractor-details.component.html',
    styleUrl: './select-contractor-details.component.css',
    standalone: false
})
export class SelectContractorDetailsComponent {
  @Input() contractor: Contractor;
  @Input() showClear: boolean = true;
  @Output() cleared: EventEmitter<void> = new EventEmitter();
  templateForPermitForm: boolean;

  clearSelection() {
    this.contractor = null;
    this.cleared.emit();
  }
  constructor(public layoutService: LayoutService, context : WorkflowContextService) {
     //added by priya 24-12-2025
      layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
     //end by priya 24-12-2025
    }
}
